/*******************************************************************************
ACTIVATE CLOUDINARY IMAGES
Activate the images on the page that are being loaded through Cloudinary.
*******************************************************************************/

import hideHiddenImages from './hide-hidden-images';
import restoreHiddenImages from './restore-hidden-images';

export default function activateCloudinaryImages() {
    const $cloudinaryImages = $('.cld-responsive').filter(':visible');

    // If there are no Cloudinary images on the page, exit out
    if ($cloudinaryImages.length === 0) { return; }

    // Set the breakpoints to determine when a new image is created
    const myBreakpoints = function generateBreakpoints(width) {
        if (width <= 100) { return 10 * Math.ceil(width / 10); }
        if (width <= 1000) { return 50 * Math.ceil(width / 50); }
        return 100 * Math.ceil(width / 100);
    };

    if (window.cloudinary !== undefined) {

        if (!window.rwCloudinaryFunctionInitialized) {

            // keep a reference to the original function
            const origUpdateFn = window.cloudinary.Cloudinary.prototype.cloudinary_update;

            // This prevents hidden images from being processed by Cloudinary at a width of zero
            // Without this wrapper, a 404 error is triggered for every hidden image
            window.cloudinary.Cloudinary.prototype.cloudinary_update = function newUpdateFn() {
                hideHiddenImages();
                origUpdateFn.apply(this, arguments); // eslint-disable-line
                restoreHiddenImages();
            };

            window.rwCloudinaryFunctionInitialized = true;
        }

        window.cloudinary.Cloudinary.new({
            responsive_use_breakpoints: true,
            breakpoints               : myBreakpoints,
            cloud_name                : 'rotowire',
        }).responsive();
    }

    // Lazy load dynamically added images
    if (window.rwLazyLoader !== undefined) { window.rwLazyLoader.observe(); }

    // Get all the images that have a credited source attached to them
    const $imagesWithCredit = $('img[data-credit]');

    // If there are no Cloudinary images that have a credited source, exit out here
    if ($imagesWithCredit.length === 0) { return; }

    // Add photo credits section in footer
    if ($('.photo-credits').length === 0) {
        $('.site-footer').append(`
            <div class="photo-credits">
                <div class="photo-credits__head">Photo Credits</div>
                <ol class="photo-credits__list"></ol>
            </div>
        `);
    }
    // Clear out the photo credit list if the section already exists
    else {
        $('.photo-credits__list').empty();
    }

    // Add individual photo credits to the list
    $imagesWithCredit.each(function addImageCredits(index) {
        const $image = $(this);
        const imageCredit = $image.data('credit') || '';
        const creditLink = $image.data('creditlink') || '';
        const imageNumber = index + 1;

        // Give the image a unique ID (or use the existing one)
        const uniqueImageID = $image.attr('id') === undefined ? `cld-img${imageNumber}` : $image.attr('id');
        $image.attr('id', uniqueImageID);

        if (imageCredit) {
            const creditWithLink = `<a target="_blank" href="${creditLink}">${imageCredit}</a>&nbsp;&nbsp; <a href="#${uniqueImageID}"><img alt="Jump To Image" src="https://content.rotowire.com/images/eye-icon.png"></a>`;
            const creditNoLink = `${imageCredit}&nbsp;&nbsp; <a href="#${uniqueImageID}"><img alt="Jump To Image" src="https://content.rotowire.com/images/eye-icon.png"></a>`;
            const creditItem = (creditLink) ? creditWithLink : creditNoLink;
            $('.photo-credits__list').append(`<li>${creditItem}</li>`);
        }
    });
}
